<template>
  <div>
    <title-screen title ="12"></title-screen>
    <div v-if="isShowSurvey">
    以下のアンケートに、率直なご意見・ご要望をご記入ください。
      <el-form ref="survey" :model="survey" :rules="rules" class="survey-form">
        <div class="contents">
          <div class="content">
            <div class="question">
              Q1: 相続手続きは何回目ですか？
            </div>
            <div class="answer">
              <el-form-item prop="answer1">
                <el-radio-group v-model="survey.answer1" class="servey-radio">
                  <el-radio :label="1">一回目</el-radio>
                  <el-radio :label="2">ニ回目</el-radio>
                  <el-radio :label="3">三回目以上</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="comment">
                <div class="comment-label">コメント</div>
                <div class="comment-container">
                  <textarea class="comment-area" v-model="survey.comment1"></textarea>
                </div>
            </div>
          </div>
          <div class="content">
            <div class="question">
              Q2.1: 相続税申告につき何社から情報を集めましたか？
            </div>
            <div class="answer">
              <el-form-item prop="answer2">
                <el-radio-group v-model="survey.answer2" class="servey-radio" @change="handleRequired21">
                  <el-radio :label="1">一社（レガシィのみ）</el-radio>
                  <el-radio :label="2">二社</el-radio>
                  <el-radio :label="3">三社</el-radio>
                  <el-radio :label="4">四社以上</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="comment">
                <div class="comment-label">コメント</div>
                <div class="comment-container">
                  <textarea class="comment-area" v-model="survey.comment2"></textarea>
                </div>
            </div>
          </div>
          <div class="content">
            <div class="question">
              Q2.2: それはどちらですか？（税理士法人・事務所等）
            </div>
            <el-form-item  class="comment special-comment" prop="comment22">
              <div>
                <div class="comment-label">コメント</div>
                <div class="comment-container">
                  <textarea class="comment-area" v-model="survey.comment22" @input="handleInput"></textarea>
                </div>
              </div>
              <div class="el-form-item__error" v-show="comment22Error">{{this.$t('rules.no_comment', { key: this.$t('survey.question_2b') })}}</div>
            </el-form-item>
          </div>
          <div class="content">
            <div class="question">
              Q3: 当社を何で知りましたか？
              <br>※複数選択可
            </div>
            <div class="answer">
              <el-form-item prop="answer3">
                <el-checkbox-group v-model="survey.answer3">
                    <el-checkbox label="1">インターネット</el-checkbox>
                    <el-checkbox label="2">新聞・雑誌</el-checkbox>
                    <el-checkbox label="3">書籍</el-checkbox>
                    <el-checkbox label="4">セミナー</el-checkbox>
                    <el-checkbox label="5">親戚・知人</el-checkbox>
                    <el-checkbox label="6">金融機関</el-checkbox>
                    <el-checkbox label="7">葬儀社</el-checkbox>
                    <el-checkbox label="8">郵送物</el-checkbox>
                    <el-checkbox label="9">その他（コメント欄へ）</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
            <el-form-item prop="comment3">
              <div class="comment">
                <div class="comment-label">コメント</div>
                <div class="comment-container">
                  <textarea class="comment-area" v-model="survey.comment3"></textarea>
                </div>
              </div>
            </el-form-item>
          </div>
          <div class="content">
            <div class="question">
              Q4: 当社をお選びいただいた理由を教えて下さい。
              <br>※複数選択可
            </div>
            <div class="answer">
              <el-form-item prop="answer4">
                <el-checkbox-group v-model="survey.answer4">
                    <el-checkbox label="1">紹介者への信頼</el-checkbox>
                    <el-checkbox label="2">提案内容が良い</el-checkbox>
                    <el-checkbox label="3">専門知識がある</el-checkbox>
                    <el-checkbox label="4">対応が良い</el-checkbox>
                    <el-checkbox label="5">説明がわかりやすい</el-checkbox>
                    <el-checkbox label="6">価格が適切</el-checkbox>
                    <el-checkbox label="7">節税効果が高い</el-checkbox>
                    <el-checkbox label="8">その他（コメント欄へ）</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
            <el-form-item prop="comment4">
              <div class="comment">
                <div class="comment-label">コメント</div>
                <div class="comment-container">
                  <textarea class="comment-area" v-model="survey.comment4"></textarea>
                </div>
              </div>
            </el-form-item>
          </div>
          <div class="content">
            <div class="question">
              Q5: ご提案時の業務内容をすべてお手伝いいたしましたか？
            </div>
            <div class="answer">
              <el-form-item prop="answer5">
                <el-radio-group v-model="survey.answer5" class="survey-radio">
                  <el-radio :label="1">した</el-radio>
                  <el-radio :label="2">していない</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="comment">
              <div class="comment-label">コメント</div>
              <div class="comment-container">
                <textarea class="comment-area" v-model="survey.comment5"></textarea>
              </div>
            </div>
          </div>
          <div class="content">
            <div class="question">
              Q6: 相続手続で一番苦労されたこと、もしくはおっくうだと感じたことは何でしたか？
              <br>※複数選択可
            </div>
            <div class="answer">
              <el-form-item prop="answer6">
                <el-checkbox-group v-model="survey.answer6">
                    <el-checkbox label="1">資料探し、取寄せ</el-checkbox>
                    <el-checkbox label="2">銀行の名義変更</el-checkbox>
                    <el-checkbox label="3">相続人間の分割協議</el-checkbox>
                    <el-checkbox label="4">納税の工面</el-checkbox>
                    <el-checkbox label="5">その他（コメント欄へ）</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
            <el-form-item prop="comment6">
              <div class="comment">
                <div class="comment-label">コメント</div>
                <div class="comment-container">
                  <textarea class="comment-area" v-model="survey.comment6"></textarea>
                </div>
              </div>
            </el-form-item>
          </div>
          <div class="content">
            <div class="question">
              Q7: 当初お客様が抱いていた期待感と実際のお手伝いとを比べていかがでしたか？
            </div>
            <div class="answer">
              <el-form-item prop="answer7">
                <el-radio-group v-model="survey.answer7" class="survey-radio">
                  <el-radio :label="1">期待以上</el-radio>
                  <el-radio :label="2">期待どおり</el-radio>
                  <el-radio :label="3">期待以下</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="comment">
              <div class="comment-label">コメント</div>
              <div class="comment-container">
                <textarea class="comment-area" v-model="survey.comment7"></textarea>
              </div>
            </div>
          </div>
          <div class="content">
            <div class="question">
              Q8: お知り合いに当社を紹介したいと思われますか？
            </div>
            <div class="answer">
              <el-form-item prop="answer8">
                <el-radio-group v-model="survey.answer8" class="survey-radio">
                  <el-radio :label="1">思う</el-radio>
                  <el-radio :label="2">どちらでもない</el-radio>
                  <el-radio :label="3">思わない</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="comment">
              <div class="comment-label">コメント</div>
              <div class="comment-container">
                <textarea class="comment-area" v-model="survey.comment8"></textarea>
              </div>
            </div>
          </div>
          <div class="content">
            <div class="question">
              Q9: 不動産に関する総合コンサルティングでご興味があるものはございますか？
              <br>※複数選択可
            </div>
            <div class="answer">
              <el-form-item prop="answer9">
                <el-checkbox-group v-model="survey.answer9">
                    <el-checkbox label="1">相続を視野に入れた不動産整備</el-checkbox>
                    <el-checkbox label="2">資金繰り改善のための不動産売却</el-checkbox>
                    <el-checkbox label="3">不動産有効利用相談</el-checkbox>
                    <el-checkbox label="4">借地人との権利関係の整備</el-checkbox>
                    <el-checkbox label="5">震災対策としての賃貸建物の建替え</el-checkbox>
                    <el-checkbox label="6">建物のリフォーム</el-checkbox>
                    <el-checkbox label="7">その他（コメント欄へ）</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
            <el-form-item prop="comment9">
              <div class="comment">
                <div class="comment-label">コメント</div>
                <div class="comment-container">
                  <textarea class="comment-area" v-model="survey.comment9"></textarea>
                </div>
              </div>
            </el-form-item>
          </div>
          <div class="content">
            <div class="question">
              Q10: 相続した自社株のある方でご興味があるものはございますか？
              <br>※複数選択可
            </div>
            <div class="answer">
              <el-form-item prop="answer10">
                  <el-checkbox-group v-model="survey.answer10">
                      <el-checkbox label="1">自社株なし</el-checkbox>
                      <el-checkbox label="2">株主への移動を考えている</el-checkbox>
                      <el-checkbox label="3">場合によっては自社株式の評価</el-checkbox>
                      <el-checkbox label="4">場合によっては自社株式の贈与</el-checkbox>
                      <el-checkbox label="5">納税猶予</el-checkbox>
                      <el-checkbox label="6">その他（コメント欄へ）</el-checkbox>
                  </el-checkbox-group>
              </el-form-item>
            </div>
            <el-form-item prop="comment10">
              <div class="comment">
                <div class="comment-label">コメント</div>
                <div class="comment-container">
                  <textarea class="comment-area" v-model="survey.comment10"></textarea>
                </div>
              </div>
            </el-form-item>
          </div>
          <div class="content">
            <div class="question">
              Q11: 今後の家族信託の活用についてどのようにお考えですか？
              <br>※複数選択可
            </div>
            <div class="answer">
              <el-form-item prop="answer11">
                <el-checkbox-group v-model="survey.answer11">
                    <el-checkbox label="1">おっくうなことを家族に託したい</el-checkbox>
                    <el-checkbox label="2">次の相続、さらにその次の相続を相談したい</el-checkbox>
                    <el-checkbox label="3">将来の認知症になった後が気になっている</el-checkbox>
                    <el-checkbox label="4">家族信託について興味がある</el-checkbox>
                    <el-checkbox label="5">家族信託については興味がない</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
            <div class="comment">
              <div class="comment-label">コメント</div>
              <div class="comment-container">
                <textarea class="comment-area" v-model="survey.comment11"></textarea>
              </div>
            </div>
          </div>
          <div class="content">
            <div class="question">
              Q12: これからのことでレガシィに紹介してもらいたい会社はどれですか？
              <br>※複数選択可
            </div>
            <div class="answer">
              <el-form-item prop="answer12">
                <el-checkbox-group v-model="survey.answer12">
                    <el-checkbox label="1">リゾート会員権の会社</el-checkbox>
                    <el-checkbox label="2">ゴルフ倶楽部</el-checkbox>
                    <el-checkbox label="3">会員制医療倶楽部</el-checkbox>
                    <el-checkbox label="4">介護施設</el-checkbox>
                    <el-checkbox label="5">葬儀社</el-checkbox>
                    <el-checkbox label="6">引っ越し準備の家財整理会社</el-checkbox>
                    <el-checkbox label="7">オーダーメイドの旅行会社</el-checkbox>
                    <el-checkbox label="8">有名建築家紹介会社</el-checkbox>
                    <el-checkbox label="9">その他（コメント欄へ）</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
            <el-form-item prop="comment12">
              <div class="comment">
                <div class="comment-label">コメント</div>
                <div class="comment-container">
                  <textarea class="comment-area" v-model="survey.comment12"></textarea>
                </div>
              </div>
            </el-form-item>
          </div>
          <div class="content">
            <div class="question">
              Q13: 弊社のお手伝いについて良かった点・悪かった点のご意見・ご感想をお聞かせください。
            </div>
            <el-form-item class="comment special-comment" prop="comment13">
              <div>
                <div class="comment-label">コメント</div>
                <div class="comment-container">
                  <textarea class="comment-area" v-model="survey.comment13"></textarea>
                </div>
              </div>
            </el-form-item>
          </div>
          <div class="answer sharing-prohibited">
              <el-form-item prop="sharingProhibited">
                  <el-checkbox v-model="survey.sharingProhibited">ご紹介していただいた企業様とのアンケート内容の共有を望まない方は✔をしてください。</el-checkbox>
              </el-form-item>
          </div>
          アンケートにご協力いただき、ありがとうございました。<br>
          【回答する】ボタンから、アンケートのご回答をお願いいたします。
        </div>
        <div class="survey-button">
          <el-button @click="resetForm">{{ $t('commons.cancellation') }}</el-button>
          <el-button @click="submitForm('survey')" >回答する</el-button>
        </div>
      </el-form>
    </div>
    <div class="require-login" v-else>
      {{ this.displayMessage }}
    </div>
    <div class="survey-google" v-if="isShowGoogleLink">
        <div>
            よろしければ、Googleクチコミへの投稿もお願いいたします。<br>
            クチコミは<a href="https://g.page/legacytaxport/review?gm" target="_blank" rel="noopener noreferrer" class="text-link">こちら</a>から
        </div>
        <img v-lazy="require('@/images/survey/legacy_QR.png')" alt="">
    </div>

     <confirm-dialog
      ref="confirm-reset-form"
     ></confirm-dialog>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import surveyApi from '@/api/survey/survey-client.js'
  import TitleScreen from '@/components/common/TitleScreen'
  import { SET_OPEN_LOGIN_DIALOG } from '@/store/actions.type'
  import ConfirmDialog from '../../../../components/dialog/ConfirmDialog'
  export default {
    name: 'CustomerSurvey',
    components: {
    ConfirmDialog,
    TitleScreen
   },
    data () {
      return {
        comment22Error: false,
        survey: {
          ankenId: 0,
          answer1: '',
          comment1: '',
          answer2: [],
          comment2: '',
          answer22: '',
          comment22: '',
          answer3: [],
          comment3: '',
          answer4: [],
          comment4: '',
          answer5: '',
          comment5: '',
          answer6: [],
          comment6: '',
          answer7: '',
          comment7: '',
          answer8: '',
          comment8: '',
          answer9: [],
          comment9: '',
          answer10: [],
          comment10: '',
          answer11: [],
          comment11: '',
          answer12: [],
          comment12: '',
          answer13: '',
          comment13: '',
          sharingProhibited: false
        },
        rules: {
          answer1: [
            { required: true, message: this.$t('rules.no_answer', { key: this.$t('survey.question_1') }), trigger: 'change' }
          ],
          answer2: [
            { required: true, message: this.$t('rules.no_answer', { key: this.$t('survey.question_2') }), trigger: 'change' }
          ],
          comment22: [
            { required: false, message: this.$t('rules.no_comment', { key: this.$t('survey.question_2b') }), trigger: 'blur' }
          ],
          answer3: [
            { type: 'array', required: true, message: this.$t('rules.no_answer', { key: this.$t('survey.question_3') }), trigger: 'change' }
          ],
          answer4: [
            { type: 'array', required: true, message: this.$t('rules.no_answer', { key: this.$t('survey.question_4') }), trigger: 'change' }
          ],
          answer5: [
            { required: true, message: this.$t('rules.no_answer', { key: this.$t('survey.question_5') }), trigger: 'change' }
          ],
          answer6: [
            { type: 'array', required: true, message: this.$t('rules.no_answer', { key: this.$t('survey.question_6') }), trigger: 'change' }
          ],
          answer7: [
            { required: true, message: this.$t('rules.no_answer', { key: this.$t('survey.question_7') }), trigger: 'change' }
          ],
          answer8: [
            { required: true, message: this.$t('rules.no_answer', { key: this.$t('survey.question_8') }), trigger: 'change' }
          ],
          answer9: [
            { type: 'array', required: true, message: this.$t('rules.no_answer', { key: this.$t('survey.question_9') }), trigger: 'change' }
          ],
          answer10: [
            { type: 'array', required: true, message: this.$t('rules.no_answer', { key: this.$t('survey.question_10') }), trigger: 'change' }
          ],
          answer11: [
            { type: 'array', required: true, message: this.$t('rules.no_answer', { key: this.$t('survey.question_11') }), trigger: 'change' }
          ],
          answer12: [
            { type: 'array', required: true, message: this.$t('rules.no_answer', { key: this.$t('survey.question_12') }), trigger: 'change' }
          ],
          comment13: [
            { required: true, message: this.$t('rules.no_comment', { key: this.$t('survey.question_13') }), trigger: 'blur' }
          ]
        },
        memberId: 0,
        isShowSurvey: false,
        isShowGoogleLink: false,
        displayMessage: ''
      }
    },
    computed: {
      ...mapGetters(['isAuthenticated', 'currentUser'])
    },
    watch: {
      isAuthenticated () {
        this.setData()
      }
    },
    async created () {
      try {
        this.token = this.$route.query.token
        if (!this.token) {
          this.displayMessage = 'URLが無効です。'
          this.isShowSurvey = false
          this.isShowGoogleLink = false
          return
        }

        const res = await surveyApi.getSurveyInfo(this.token)
        const { memberId, ankenId } = res.data
        this.fetchData()

        this.memberId = memberId
        this.survey.ankenId = ankenId
        this.setData()
      } catch (e) {
        this.isShowGoogleLink = false
        switch (e.response.data.message) {
          case 'The url has expired':
            this.displayMessage = 'URLの有効期限が切れました。'
            break
          case 'Token not found':
            this.displayMessage = 'URLが無効です。'
            break
          case 'The url have been used':
            this.displayMessage = '既にアンケートのご回答をいただいております。ご協力ありがとうございました。'
            this.isShowGoogleLink = true
            break
          default:
            this.displayMessage = 'URLが無効です。'
        }
        this.isShowSurvey = false
      }
    },
    methods: {
      fetchData () {
          let memberId = this.currentUser.id === undefined ? '' : this.currentUser.id
          if (memberId === '' || memberId === undefined) {
              this.openLoginDialog()
          }
      },
      alertMessage (message, title) {
        this.$alert(message, title, {
          confirmButtonText: this.$t('commons.ok')
        })
      },
      openLoginDialog () {
          this.$store.dispatch(SET_OPEN_LOGIN_DIALOG, true)
      },
      submitForm (formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
              if (this.comment22Error === false) {
                  // call api
                  surveyApi.create(this.token, this.survey).then(response => {
                      this.displayMessage = 'ご回答ありがとうございます。'
                      this.isShowSurvey = false
                      this.isShowGoogleLink = true
                  }).catch(error => {
                      this.alertMessage(error.message, 'エラー')
                  })
              } else {
                  this.alertMessage('再度に入力情報をご確認ください。', '入力情報エラー')
              }
          } else {
            this.alertMessage('再度、入力内容をご確認ください。', '入力情報エラー')
          }
        })
      },
      setData () {
        this.isShowGoogleLink = false
        if (!this.isAuthenticated) {
          // this.displayMessage = 'アンケートを回答する前にごログインください。'
          return
        }

        if (this.currentUser.id !== this.memberId) {
          this.displayMessage = 'アンケートに紐づいた会員が不正です。'
          return
        }

        let _self = this
        surveyApi.check(_self.survey.ankenId).then(responseSurvey => {
          if (responseSurvey.data.data.isAnswered) {
              _self.displayMessage = '既にアンケートのご回答をいただいております。'
              _self.isShowGoogleLink = true
          } else {
              _self.isShowSurvey = true
          }
        }).catch(e => {
          this.displayMessage = 'アンケートに紐づいたご依頼が不正です。'
        })
      },
      resetForm () {
         this.$refs['confirm-reset-form'].open({
            message: '入力内容がクリアされますがよろしいですか？'
           }).then((confirm) => {
            if (confirm) {
              this.survey.answer1 = ''
              this.survey.answer2 = []
              this.survey.answer3 = []
              this.survey.answer4 = []
              this.survey.answer5 = ''
              this.survey.answer6 = []
              this.survey.answer7 = ''
              this.survey.answer8 = ''
              this.survey.answer9 = []
              this.survey.answer10 = []
              this.survey.answer11 = []
              this.survey.answer12 = []
              this.survey.answer1 = ''
              this.survey.comment1 = ''
              this.survey.comment2 = ''
              this.survey.comment22 = ''
              this.survey.comment3 = ''
              this.survey.comment4 = ''
              this.survey.comment5 = ''
              this.survey.comment6 = ''
              this.survey.comment7 = ''
              this.survey.comment8 = ''
              this.survey.comment9 = ''
              this.survey.comment10 = ''
              this.survey.comment11 = ''
              this.survey.comment12 = ''
              this.survey.comment13 = ''
              this.survey.sharingProhibited = false
          }
        })
      },
      handleRequired21 (val) {
          if (val === 1) {
              this.comment22Error = false
          } else {
              this.comment22Error = true
              this.handleInput()
          }
      },
      handleInput () {
          if (this.survey.comment22.length > 0) {
              this.comment22Error = false
          } else {
              this.comment22Error = true
          }
      }
    }
  }
</script>

<style>
@import 'customer_survey.css';
</style>
